import {ANY_COMMON_BUILDING_TOKEN, ANY_SPECIAL_BUILDING_TOKEN} from "../../constants/tokens";

export const checkIfAnyBuildingToken = (tokenId) => {
  return tokenId === ANY_COMMON_BUILDING_TOKEN.id || tokenId === ANY_SPECIAL_BUILDING_TOKEN.id;
}